import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CraneIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15 5.00004V5.50004C15 5.77619 14.7761 6.00004 14.5 6.00004H14V10H13V6.00004H6.85714L7.35714 13H4.64286L5.14286 6.00004H3V6.5C3 6.77614 2.77614 7 2.5 7H1.5C1.22386 7 1 6.77614 1 6.5V4.00004L5.57255 1.03834C5.78432 0.900183 6.05454 0.880558 6.28483 0.986611L15 5.00004ZM11.6547 4.58188L6.58922 2.24918L6.71429 4.00004H7L11.6547 4.58188ZM2.78967 4.00004H5.28571L5.40318 2.35553L2.78967 4.00004Z"
		></path>
		<path
			fill="currentColor"
			d="M5.03021 15H3V14.5C3 14.2239 3.22386 14 3.5 14H8.5C8.77614 14 9 14.2239 9 14.5V15H6.96979L6.96301 15H5.03699L5.03021 15Z"
		></path>
		<path
			fill="currentColor"
			d="M13.9172 11H13.0828C13.0298 11 12.9789 11.0211 12.9414 11.0586L12.0586 11.9414C12.0211 11.9789 12 12.0298 12 12.0828V12.8C12 12.9105 12.0895 13 12.2 13H14.8C14.9105 13 15 12.9105 15 12.8V12.0828C15 12.0298 14.9789 11.9789 14.9414 11.9414L14.0586 11.0586C14.0211 11.0211 13.9702 11 13.9172 11Z"
		></path>
	</svg>
))
